var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CenterIconMessage d-flex align-items-center justify-content-center flex-column p-4"},[_c('i',{class:[_vm.icon, 'mb-3']}),_c('h1',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }